import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { MyWorkPage } from "../components/my-work/MyWorkPage";
import { myWorkSearchSchema } from "../components/my-work/my-work-search";

/** My work's Reported by me (BUILD_SPEC §12.7), its peek's issue in the address. */
function Page() {
  const search = useSearch({ from: "/admin/my/reported" });
  const navigate = useNavigate({ from: "/admin/my/reported" });
  return (
    <MyWorkPage
      view="reported"
      search={search}
      onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  );
}

export const Route = createFileRoute("/admin/my/reported")({ validateSearch: myWorkSearchSchema, component: Page });
